// Copyright (c) 2017 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const ComponentCodes = t.list(KeyValuePair, 'ComponentCodes');

export const getDefaultState = () => new ComponentCodes([]);

export default ComponentCodes;



// WEBPACK FOOTER //
// ./src/product/details/state/component-codes.js